<template>
  <div class="provider-button-card" @click="$emit('submit')">
    <!-- Левая секция -->
    <div class="provider-button-card__left">
      <div class="provider-button-card__title">
        {{ title }}
      </div>
      <div v-if="subtitle" class="provider-button-card__subtitle">{{ subtitle }}</div>
    </div>

    <!-- Центральная секция -->
    <div v-if="monthlyPayment?.amount" class="provider-button-card__center">
      <div class="provider-button-card__payment-amount">
        от {{ monthlyPayment.amount + ' руб' }}
      </div>
      <div class="provider-button-card__payment-label">Платеж в месяц</div>
    </div>

    <!-- Правая секция -->

    <button class="provider-button-card__btn">
      Выбрать
    </button>

  </div>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, required: false, default: '' },
  monthlyPayment: {
    type: Object as () => { amount?: number; term?: number } | undefined,
    required: false
  },
  defaultAmount: { type: String, default: '1000₽' }
})

defineEmits(['submit'])
</script>

<style scoped lang="scss">
.provider-button-card {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr auto;
  border: 2px solid transparent;
  border-radius: 20px;
  padding: 20px;
  gap: 8px;
  background: #f7f9fa;
  cursor: pointer;
  transition: 0.25s ease;

  @include mobile {
    grid-template-columns: 1fr 1fr;
     gap: 16px;
  }
}

.provider-button-card__left,
.provider-button-card__center {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
}

.provider-button-card:hover {
  border: 2px solid #cbdbf7;
  background-color: #f3f5f7;
}

.provider-button-card__title {
  font-weight: 600;
  font-size: 18px;
  line-height: 135%;
  color: #000;
}

.provider-button-card__subtitle {
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  color: #58595a;
}

.provider-button-card__payment-label {
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  color: #58595a;

  @include mobile {
    text-align: right;
  }
}

.provider-button-card__payment-amount {
  font-weight: 600;
  font-size: 18px;
  line-height: 135%;
  color: #000;

  @include mobile {
    text-align: right;
  }
}

.provider-button-card__btn {
  font-weight: 400;
  font-size: 15px;
  line-height: 133%;
  color: rgba(0, 0, 0, 0.85);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 44px;
  border:none;
  background-color: #fff;
  margin-left: auto;

  @include mobile {

    width: 100%;
    grid-column: span 2;
  }
}

.provider-button-card__btn:hover {
  opacity: 0.8;
}
</style>